{
  "de": {
    "materialGenerationPromptModal": {
      "buttons": {
        "generate": "Vorschlag generieren"
      },
      "description": "Der Entwurf des {material} basiert auf deinen {sourceKind}-Inhalt und ist immer editier- und erweiterbar.",
      "headers": {
        "fallbackTitle": "Material mit KI erstellen",
        "title": "{material} zum {sourceKind} mit KI erstellen"
      },
      "labels": {
        "language": "Sprache",
        "prompt": "Anforderungen"
      },
      "help": {
        "prompt": "Beschreibe hier zusätzlich die Zielgruppe, Unterrichtskontext und Fokus für das {material}. Nenne ggf. Leitfrage, Lernziel oder besondere Anforderungen."
      },
      "placeholders": {
        "prompt": "Weitere Anforderungen ergänzen..."
      }
    }
  }
}
